import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateWorkspace } from 'js/actions/workspace-actions';

import ChangeWorkspaceName from 'js/routes/WorkspaceSettings/components/ChangeWorkspaceName';
import WorkspaceAiUsage from 'js/routes/WorkspaceSettings/components/WorkspaceAiUsage';
import { withRouter } from 'react-router-dom';
import { notify } from 'js/actions/alert-actions';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';
import { request } from 'js/api/axios';

function CoreWorkspaceSettingsContainer({
  updateWorkspace,
  notify,
  activeWorkspace,
  match,
  token,
}) {
  const [aiUsage, setAiUsage] = useState(null);

  const onSubmit = useCallback(
    async (workspaceName) => {
      try {
        await updateWorkspace(workspaceName, activeWorkspace.id);
        notify({
          type: 'success',
          message: 'Workspace name updated successfully',
        });
      } catch (e) {}
    },
    [activeWorkspace, updateWorkspace, notify]
  );

  useEffect(() => {
    if (!activeWorkspace?.id || !token) {
      return;
    }

    request
      .get(`/api/workspaces/${activeWorkspace.id}/ai-usage`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((resp) => setAiUsage(resp.data?.data ?? null))
      .catch(() => setAiUsage(null));
  }, [activeWorkspace?.id, token]);

  return (
    <div>
      <ChangeWorkspaceName
        workspace={activeWorkspace}
        onSubmit={onSubmit}
        match={match}
      />
      <WorkspaceAiUsage usage={aiUsage} />
    </div>
  );
}

export default withRouter(
  connect(
    (store) => ({
      activeWorkspace: selectActiveWorkspace(store),
      token: store.identity.token,
    }),
    {
      updateWorkspace,
      notify,
    }
  )(CoreWorkspaceSettingsContainer)
);
